var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useCallback, useContext, useEffect, useMemo, useRef, useState } from 'react';
import Dropdown from '../../components/DropDown';
import '../../styles/widgets/popup/cardsManipulativePopup.scss';
import ButtonComponent from '../../components/ButtonComponent';
import globalStore from '../../store';
import RadioButton from '../../components/RadioButton';
import { t } from 'i18next';
import CustomScrollbar from '../../components/CustomScrollbar';
import { v4 as uuidv4 } from 'uuid';
import FooterActionsButtons from './FooterActionsButtons';
import MathEditor from '../../components/MathEditor';
import { DataContext } from '../../player/DataContext';
import { useOnResize } from '../../helper/hooks/onResize';
import CheckBox from '../../components/CheckBox';
import { CARD_IMAGES, GRADES, MIN_CARD_COUNT, MAX_CARD_COUNT, } from '../../constants/cardDeckConfig';
import { getImageSrc } from '../../helper/imageBlobCache';
import { shuffleArray } from '../../helper/shuffleArray';
var convertSingleCardFaceToCards = function (faces) {
    var map = new Map();
    faces.forEach(function (face) {
        var probabilityId = face.probabilityId, text = face.text, type = face.type, cardData = __rest(face, ["probabilityId", "text", "type"]);
        if (!map.has(probabilityId)) {
            map.set(probabilityId, {
                probabilityId: probabilityId,
                text: text,
                lock: { positioning: false, editing: false },
                count: 0,
                multipleProbabilityCard: [],
                type: type,
            });
        }
        var entry = map.get(probabilityId);
        entry.multipleProbabilityCard.push(cardData);
        entry.count = entry.multipleProbabilityCard.length;
    });
    return Array.from(map.values());
};
var CardsManipulativePopup = function (props) {
    var propsCard = props.cards, onSubmit = props.onSubmit, _a = props.rotate, rotate = _a === void 0 ? false : _a, onCancel = props.onCancel, _b = props.deckType, deckTypeProps = _b === void 0 ? 'preMadeDeck' : _b, _c = props.deckIdx, deckIdxProps = _c === void 0 ? -1 : _c, _d = props.gradeIdx, gradeIdxProps = _d === void 0 ? -1 : _d;
    var SHOW_SQUENCE_ORDER_FROM_PROPS = true;
    var _e = globalStore.useStoreState(function (store) { return store.jsonDataStore; }), btnConfig = _e.btnConfig, bottomToolConfig = _e.bottomToolConfig, decksByGrade = _e.decksByGrade;
    // const cards: cardsData['cards'] = [
    //   {
    //     id: 'cards_123',
    //     center: {
    //       x: 0,
    //       y: 0
    //     },
    //     dimensions: {
    //     }
    //   },
    // ];
    var _f = useContext(DataContext), setSelectedTool = _f.setSelectedTool, selectedTool = _f.selectedTool;
    var _g = useState(rotate ? 'landscape' : 'portrait'), orientationMode = _g[0], setOrietationMode = _g[1];
    var _h = useState(deckTypeProps === 'preMadeDeck' ? 0 : 1), deckType = _h[0], setDeckType = _h[1];
    var _j = useState(gradeIdxProps), gradeIdx = _j[0], setGradeIdx = _j[1];
    var _k = useState(deckIdxProps), deckIdx = _k[0], setDeckIdx = _k[1];
    var _l = useState(5), totalCount = _l[0], setTotalCount = _l[1];
    var _m = useState(), preMadeDeckData = _m[0], setPreMadeDeckData = _m[1];
    var cardIndicatorRef = useRef(null);
    var initialDimension = useMemo(function () {
        return orientationMode === 'landscape' ? { width: 301, height: 215 } : { width: 215, height: 301 };
    }, [orientationMode]);
    var createProbabilityCard = useCallback(function () { return ({
        id: "card_".concat(uuidv4().replace(/-/g, '')),
        dimensions: __assign({}, initialDimension),
        placedOnDeck: false,
        position: { x: 0, y: 0 },
        showImage: 'front',
        lock: { positioning: false, editing: false },
    }); }, [initialDimension]);
    // Compute initial cards + selectedCardOrder from props (matching the Dice pattern
    // of reading from props immediately instead of via useEffect, which avoids a race
    // condition where MathEditor mounts with empty data on the first render)
    var initialCardsState = useMemo(function () {
        if (!propsCard || propsCard.length === 0) {
            return {
                cards: Array.from({ length: 5 }).map(function () { return ({
                    probabilityId: "cardProbability_".concat(uuidv4().replace(/-/g, '')),
                    text: [{ type: 'text', value: '' }],
                    count: 1,
                    type: 'text',
                    lock: { positioning: false, editing: false },
                    multipleProbabilityCard: [createProbabilityCard()],
                }); }),
                selectedCardOrder: [],
            };
        }
        var convertedCards = convertSingleCardFaceToCards(propsCard);
        if (SHOW_SQUENCE_ORDER_FROM_PROPS) {
            var orderMap_1 = [];
            convertedCards.forEach(function (card, cardIndex) {
                var face = propsCard.find(function (f) { return f.probabilityId === card.probabilityId && f.sequenceOrder != null; });
                if (face && face.sequenceOrder != null) {
                    orderMap_1.push({ cardIndex: cardIndex, sequenceOrder: face.sequenceOrder });
                }
            });
            if (orderMap_1.length > 0) {
                orderMap_1.sort(function (a, b) { return a.sequenceOrder - b.sequenceOrder; });
                var selectedIndices_1 = new Set(orderMap_1.map(function (o) { return o.cardIndex; }));
                var selectedCards = orderMap_1.map(function (o) { return convertedCards[o.cardIndex]; });
                var unselectedCards = convertedCards.filter(function (_, i) { return !selectedIndices_1.has(i); });
                return {
                    cards: __spreadArray(__spreadArray([], selectedCards, true), unselectedCards, true),
                    selectedCardOrder: orderMap_1.map(function (_, i) { return i; }),
                };
            }
        }
        return { cards: convertedCards, selectedCardOrder: [] };
    }, []);
    var _o = useState(new Set()), checkedCards = _o[0], setCheckedCards = _o[1];
    var _p = useState(initialCardsState.cards), cards = _p[0], setCards = _p[1];
    var _q = useState(initialCardsState.selectedCardOrder), selectedCardOrder = _q[0], setSelectedCardOrder = _q[1];
    var _r = useState(-1), activeMathInput = _r[0], setActiveMathInput = _r[1];
    var _s = useState(0), lastActiveMathInput = _s[0], setLastActiveMathInput = _s[1];
    var _t = useState(false), uniformFontSize = _t[0], setUniformFontSize = _t[1];
    var _u = useState(true), allCardsEmpty = _u[0], setAllCardsEmpty = _u[1];
    var _v = useState(false), allCardsFilled = _v[0], setAllCardsFilled = _v[1];
    var _w = useState(''), popupAnnounce = _w[0], setPopupAnnounce = _w[1];
    var deckCardWrapperRef = useRef(null);
    var mathEditorRefs = useRef([]);
    var cardCountRefs = useRef([]);
    var createDeckLabelRef = useRef(null);
    // Tracks the last editor the user explicitly focused. Text cbs are only accepted
    // from this editor to block mount-time getMathData() calls from all non-focused editors.
    // Intentionally NOT reset to -1 on blur so that the blur getMathData() cb still goes through.
    var activeMathInputRef = useRef(-1);
    var prevActiveMathInputRef = useRef(-1);
    var runnedFirstTime = useRef(false);
    var contentWrapperRef = useRef(null);
    if (!decksByGrade.length)
        return null;
    var localObj = __assign(__assign({}, CARD_IMAGES), { deckType: [t('text.preMadeDeck'), t('text.createYourOwn')], grade: GRADES.slice(0, decksByGrade.length), deck: decksByGrade, minCardCount: MIN_CARD_COUNT, maxCardCount: MAX_CARD_COUNT });
    useEffect(function () {
        setPreMadeDeckData(function () {
            var _gradeData = localObj.grade.map(function (item) { return item.value; });
            var _deckData = localObj.deck.map(function (deckArray) {
                return deckArray.map(function (item) { return item.value; });
            });
            return {
                grade: _gradeData,
                deck: _deckData,
            };
        });
    }, [decksByGrade]);
    var handleDropDown = useCallback(function (dropdownId, data) {
        switch (dropdownId) {
            case 'gradeDropDown':
                setGradeIdx(data.index);
                setDeckIdx(-1);
                setSelectedCardOrder([]);
                break;
            case 'deckDropDown':
                setDeckIdx(data.index);
                setSelectedCardOrder([]);
                var deckData_1 = localObj.deck[gradeIdx][data.index];
                if (deckData_1.defaultOrientation)
                    setOrietationMode(deckData_1.defaultOrientation);
                // Dimensions are computed directly from deckData.defaultOrientation rather than
                // via createProbabilityCard()/initialDimension, which are keyed on orientationMode
                // state and can still be stale here: if the previously selected deck already had
                // the same orientation, setOrietationMode() above is a no-op and the corrective
                // [orientationMode] effect never re-fires to fix these dimensions afterward.
                var deckDimensions_1 = deckData_1.defaultOrientation === 'landscape'
                    ? { width: 301, height: 215 }
                    : { width: 215, height: 301 };
                var buildProbabilityCard_1 = function () { return (__assign(__assign({}, createProbabilityCard()), { dimensions: __assign({}, deckDimensions_1) })); };
                setCards(function () {
                    var _a;
                    if ('texts' in deckData_1 && deckData_1.texts) {
                        return deckData_1.texts.map(function (textValue) { return ({
                            probabilityId: "cardProbability_".concat(uuidv4().replace(/-/g, '')),
                            text: textValue,
                            count: 1,
                            type: 'text',
                            lock: { positioning: false, editing: false },
                            multipleProbabilityCard: [buildProbabilityCard_1()],
                        }); });
                    }
                    var imageList = deckData_1.defaultOrientation === 'landscape' && deckData_1.landscapeImages
                        ? deckData_1.landscapeImages
                        : ((_a = deckData_1.images) !== null && _a !== void 0 ? _a : []);
                    return imageList.map(function (_imageSrc) { return ({
                        probabilityId: "cardProbability_".concat(uuidv4().replace(/-/g, '')),
                        text: _imageSrc,
                        count: 1,
                        type: 'image',
                        lock: { positioning: false, editing: false },
                        multipleProbabilityCard: [buildProbabilityCard_1()],
                    }); });
                });
                break;
        }
    }, [gradeIdx]);
    var handleDeckType = function (value) {
        runnedFirstTime.current = true;
        setDeckType(value);
        setTimeout(function () {
            var sectionId = value === 0 ? 'preMadeDeck' : 'createDeck';
            var section = document.getElementById(sectionId);
            var firstFocusable = section === null || section === void 0 ? void 0 : section.querySelector('button:not([disabled]), input:not([disabled]), select:not([disabled]), [tabindex]:not([tabindex="-1"])');
            firstFocusable === null || firstFocusable === void 0 ? void 0 : firstFocusable.focus();
        }, 0);
    };
    var updateCount = function (index, delta) {
        var clampedCount = Math.max(localObj.minCardCount, Math.min(localObj.maxCardCount, cards[index].count + delta));
        setCards(function (prev) {
            return prev.map(function (card, i) {
                if (i !== index)
                    return card;
                var newCount = Math.max(localObj.minCardCount, Math.min(localObj.maxCardCount, card.count + delta));
                var updatedCards = __spreadArray([], card.multipleProbabilityCard, true);
                if (newCount > updatedCards.length) {
                    var toAdd = newCount - updatedCards.length;
                    updatedCards.push.apply(updatedCards, Array.from({ length: toAdd }, createProbabilityCard));
                }
                else if (newCount < updatedCards.length) {
                    updatedCards = updatedCards.slice(0, newCount);
                }
                return __assign(__assign({}, card), { count: newCount, multipleProbabilityCard: updatedCards });
            });
        });
        setPopupAnnounce(t('text.cardCountAnnounce', { index: index + 1, count: clampedCount }));
    };
    var renderPreMadeDeck = function () {
        var _a, _b, _c, _d;
        return (_jsx("div", { id: 'preMadeDeck', className: "".concat(deckType === 1 ? 'hideDeckWrapper' : ''), children: _jsxs("div", { className: "preDeckWrapper", children: [_jsxs("div", { className: "deckSelector", children: [_jsxs("div", { className: "formRow", children: [_jsx("span", { id: "grade", className: "dropdownLabel", "aria-hidden": "true", children: t('text.grade') }), _jsx(Dropdown, { id: "gradeDropDown", className: "dropdownField1", options: (_a = preMadeDeckData === null || preMadeDeckData === void 0 ? void 0 : preMadeDeckData.grade) !== null && _a !== void 0 ? _a : [], value: gradeIdx === -1 ? null : ((_b = preMadeDeckData === null || preMadeDeckData === void 0 ? void 0 : preMadeDeckData.grade[gradeIdx]) !== null && _b !== void 0 ? _b : ''), onChange: handleDropDown, labelId: 'grade' })] }), _jsxs("div", { className: "formRow", children: [_jsx("span", { id: "deck", className: "dropdownLabel", "aria-hidden": "true", children: t('text.deck') }), _jsx(Dropdown, { id: "deckDropDown", className: "dropdownField2", options: gradeIdx === -1 ? [] : ((_c = preMadeDeckData === null || preMadeDeckData === void 0 ? void 0 : preMadeDeckData.deck[gradeIdx]) !== null && _c !== void 0 ? _c : []), value: deckIdx === -1 || gradeIdx === -1
                                            ? null
                                            : ((_d = preMadeDeckData === null || preMadeDeckData === void 0 ? void 0 : preMadeDeckData.deck[gradeIdx][deckIdx]) !== null && _d !== void 0 ? _d : ''), onChange: handleDropDown, labelId: 'deck', disabled: gradeIdx === -1, tabIndex: gradeIdx === -1 ? -1 : undefined })] })] }), _jsx("div", { className: "deckPreviewBox", children: deckType === 0 && deckIdx !== -1 && (_jsxs(CustomScrollbar, { direction: "vertical", tabIndex: -1, children: [_jsx("span", { style: {
                                        position: 'absolute',
                                        width: '1px',
                                        height: '1px',
                                        padding: 0,
                                        margin: '-1px',
                                        overflow: 'hidden',
                                        clip: 'rect(0, 0, 0, 0)',
                                        whiteSpace: 'nowrap',
                                        border: 0,
                                    }, children: t('text.cardOrderDirections') }), _jsx("div", { className: "deckCardWrapper ".concat(orientationMode), ref: deckCardWrapperRef, children: deckIdx !== -1 &&
                                        gradeIdx !== -1 &&
                                        cards.map(function (_premadeDeckData, index) {
                                            var selectionIndex = selectedCardOrder.indexOf(index);
                                            var isSelected = selectionIndex !== -1;
                                            return (_jsxs("button", { className: "frontCard ".concat(isSelected ? 'selectedCards' : ''), type: "button", "aria-pressed": isSelected, "aria-label": isSelected
                                                    ? t('text.cardLabelSelected', {
                                                        number: index + 1,
                                                        order: selectionIndex + 1,
                                                    })
                                                    : t('text.cardLabel', { number: index + 1 }), onClick: function () {
                                                    setSelectedCardOrder(function (prev) {
                                                        var isCurrentlySelected = prev.includes(index);
                                                        var newOrder = isCurrentlySelected
                                                            ? prev.filter(function (i) { return i !== index; })
                                                            : __spreadArray(__spreadArray([], prev, true), [index], false);
                                                        setPopupAnnounce(isCurrentlySelected
                                                            ? t('text.cardDeselected', { index: index + 1 })
                                                            : t('text.cardSelectedOrder', {
                                                                index: index + 1,
                                                                order: newOrder.indexOf(index) + 1,
                                                            }));
                                                        return newOrder;
                                                    });
                                                }, children: [_jsx("img", { className: "frontCardImg", src: getImageSrc(orientationMode === 'landscape'
                                                            ? localObj.cardFrontLandscape
                                                            : localObj.cardFrontPortrait), "aria-hidden": "true", alt: "", draggable: false }), _jsx("div", { className: "cardText", children: _premadeDeckData.type === 'image' ? (_jsx("img", { src: getImageSrc(typeof _premadeDeckData.text === 'string'
                                                                ? _premadeDeckData.text
                                                                : ''), draggable: false, className: "cardImage", onLoad: function (e) {
                                                                var img = e.currentTarget;
                                                                img.classList.remove('cardImage--svg');
                                                                if (img.naturalHeight / img.naturalWidth < 1.2) {
                                                                    img.classList.add('cardImage--svg');
                                                                }
                                                            }, alt: "", "aria-hidden": "true" })) : (_jsx(MathEditor, { data: {
                                                                type: 'data',
                                                                data: {
                                                                    text: _premadeDeckData.text,
                                                                    color: '#000000',
                                                                    alignment: 'center',
                                                                    size: BASE_PREVIEW_FONT_SIZE,
                                                                },
                                                            }, color: "#000000", className: "displayCard", isTextUpdate: false, index: index, idPreffix: 'premadeCardText', viewonly: true, isManipulative: true })) }), isSelected && (_jsx("div", { className: "cardSelectionOverlay", "aria-hidden": "true", children: _jsx("div", { children: selectionIndex + 1 }) }))] }, index));
                                        }) })] })) }), _jsx("span", { className: "cardOrderDirections", "aria-hidden": "true", children: t('text.cardOrderDirections') })] }) }));
    };
    var handleTextChange = function (content, type, index, additionalData) {
        var idx = Number(index);
        // On focus: record which editor the user is editing. This ref is intentionally NOT reset on
        // blur so that the blur getMathData() cb (fired 100ms after blur) still passes through.
        if (type === 'focus') {
            if (idx !== -1) {
                prevActiveMathInputRef.current = activeMathInputRef.current;
                activeMathInputRef.current = idx;
                setLastActiveMathInput(idx);
            }
            return;
        }
        // Block text cbs from editors the user hasn't focused. MathEditor calls getMathData()
        // on mount (when isFocused=false) for all editors, emitting empty content that would
        // overwrite stored text and trigger re-render cascades that cancel the measurement timeout.
        // Also allow the previous active input — its blur cb arrives after the next input's focus.
        if (activeMathInputRef.current !== idx && prevActiveMathInputRef.current !== idx)
            return;
        var sanitizedValue = function (val) {
            if (!val)
                return '';
            return val.replace(/<br\s*\/?>/gi, '');
        };
        var newText = typeof content === 'string'
            ? [{ type: 'text', value: sanitizedValue(content) }]
            : content.map(function (item) {
                return item.type === 'text' ? __assign(__assign({}, item), { value: sanitizedValue(item.value) }) : __assign({}, item);
            });
        setCards(function (prev) {
            var _a;
            if (JSON.stringify((_a = prev[idx]) === null || _a === void 0 ? void 0 : _a.text) === JSON.stringify(newText))
                return prev;
            return prev.map(function (card, i) { return (i === idx ? __assign(__assign({}, card), { text: newText }) : card); });
        });
    };
    var alignIndicatorWithFirstCounter = useCallback(function () {
        var counterEl = cardCountRefs.current[0];
        var indicatorEl = cardIndicatorRef.current;
        var labelEl = createDeckLabelRef.current;
        var mathEl = mathEditorRefs.current[0];
        if (!counterEl || !indicatorEl || !labelEl)
            return;
        var counterRect = counterEl.getBoundingClientRect();
        var labelRect = labelEl.getBoundingClientRect();
        var parentEl = indicatorEl.offsetParent;
        if (!parentEl)
            return;
        var parentRect = parentEl.getBoundingClientRect();
        // 🔹 TOP from label
        var top = labelRect.top - parentRect.top;
        // 🔹 LEFT / SIZE from counter
        var left = counterRect.left - parentRect.left;
        indicatorEl.style.top = "".concat(top, "px");
        indicatorEl.style.left = "".concat(left, "px");
        indicatorEl.style.width = "".concat(counterRect.width, "px");
        indicatorEl.style.height = "".concat(counterRect.height, "px");
        labelEl.style.height = "".concat(counterRect.height, "px");
        var labelLeft = labelRect.left - parentRect.left;
        labelEl.style.maxWidth = "".concat(left - labelLeft - 4, "px");
    }, []);
    useEffect(function () {
        alignIndicatorWithFirstCounter();
    }, [cards, orientationMode, deckType, alignIndicatorWithFirstCounter]);
    // Re-align indicator when the popup's scrollable container scrolls,
    // since getBoundingClientRect values shift with scroll.
    useEffect(function () {
        var indicator = cardIndicatorRef.current;
        if (!indicator)
            return;
        var scrollParent = indicator.closest('.popupContent');
        if (!scrollParent)
            return;
        var onScroll = function () { return alignIndicatorWithFirstCounter(); };
        scrollParent.addEventListener('scroll', onScroll, { passive: true });
        return function () { return scrollParent.removeEventListener('scroll', onScroll); };
    }, [alignIndicatorWithFirstCounter]);
    useOnResize(alignIndicatorWithFirstCounter);
    // Resize counter: triggers re-measurement effects without duplicating logic
    var _x = useState(0), resizeKey = _x[0], setResizeKey = _x[1];
    var isResizeTriggerRef = useRef(false);
    useOnResize(useCallback(function () {
        isResizeTriggerRef.current = true;
        setResizeKey(function (k) { return k + 1; });
    }, []));
    var BASE_PREVIEW_FONT_SIZE = 100;
    var WRAP_THRESHOLD_FONT_SIZE = 22;
    var cardTextContainerRef = useRef(null);
    var previewRafRef = useRef(null);
    var measuredPopupSizesRef = useRef({});
    var _y = useState(BASE_PREVIEW_FONT_SIZE), previewFontSize = _y[0], setPreviewFontSize = _y[1];
    var _z = useState(false), previewShouldWrap = _z[0], setPreviewShouldWrap = _z[1];
    var cardTextRef = useCallback(function (el) {
        cardTextContainerRef.current = el;
    }, []);
    // Synchronously measures the preview card and returns the font size to use.
    // Called both from the measurement effect and directly from the Done handler.
    var measurePreviewFontSize = useCallback(function () {
        var container = cardTextContainerRef.current;
        if (!container)
            return { size: BASE_PREVIEW_FONT_SIZE, shouldWrap: false };
        var editor = container.querySelector('.displayCard .editorDiv');
        if (!editor)
            return { size: BASE_PREVIEW_FONT_SIZE, shouldWrap: false };
        // Use fixed reference card dimensions (same as thumbnails) for consistent sizing
        var refCardW = orientationMode === 'landscape' ? 301 : 215;
        var refCardH = orientationMode === 'landscape' ? 215 : 301;
        var availableWidth = refCardW * 0.8;
        var availableHeight = refCardH * 0.8;
        // Phase 1: measure at BASE size, single-line (no wrap)
        var origFontSize = editor.style.fontSize;
        var origWidth = editor.style.width;
        var origHeight = editor.style.height;
        var origOverflow = editor.style.overflow;
        var origWS = editor.style.whiteSpace;
        editor.style.fontSize = "".concat(BASE_PREVIEW_FONT_SIZE, "px");
        editor.style.width = 'max-content';
        editor.style.height = 'max-content';
        editor.style.overflow = 'visible';
        editor.style.whiteSpace = 'nowrap';
        var contentWidth = editor.scrollWidth;
        var contentHeight = editor.scrollHeight;
        if (contentWidth === 0 || contentHeight === 0) {
            editor.style.fontSize = origFontSize;
            editor.style.width = origWidth;
            editor.style.height = origHeight;
            editor.style.overflow = origOverflow;
            editor.style.whiteSpace = origWS;
            return { size: BASE_PREVIEW_FONT_SIZE, shouldWrap: false };
        }
        var scale = Math.min(availableWidth / contentWidth, availableHeight / contentHeight);
        var singleLineSize = Math.floor(BASE_PREVIEW_FONT_SIZE * scale);
        if (singleLineSize >= WRAP_THRESHOLD_FONT_SIZE) {
            editor.style.fontSize = origFontSize;
            editor.style.width = origWidth;
            editor.style.height = origHeight;
            editor.style.overflow = origOverflow;
            editor.style.whiteSpace = origWS;
            return { size: Math.min(singleLineSize, BASE_PREVIEW_FONT_SIZE), shouldWrap: false };
        }
        // Phase 2: wrap at threshold size and fit to available height
        editor.style.fontSize = "".concat(WRAP_THRESHOLD_FONT_SIZE, "px");
        editor.style.width = "".concat(availableWidth, "px");
        editor.style.height = 'max-content';
        editor.style.overflow = 'visible';
        editor.style.whiteSpace = 'normal';
        var wrappedH = editor.scrollHeight;
        editor.style.fontSize = origFontSize;
        editor.style.width = origWidth;
        editor.style.height = origHeight;
        editor.style.overflow = origOverflow;
        editor.style.whiteSpace = origWS;
        var size = wrappedH <= availableHeight
            ? WRAP_THRESHOLD_FONT_SIZE
            : Math.max(1, Math.floor(WRAP_THRESHOLD_FONT_SIZE * (availableHeight / wrappedH)));
        return { size: size, shouldWrap: true };
    }, [orientationMode]);
    useEffect(function () {
        measuredPopupSizesRef.current = {};
    }, [orientationMode, uniformFontSize, deckType, resizeKey]);
    useEffect(function () {
        var _a;
        var container = cardTextContainerRef.current;
        if (!container)
            return;
        // Skip visibility toggle on resize so text stays visible
        var isResize = isResizeTriggerRef.current;
        isResizeTriggerRef.current = false;
        // Hide preview text while measuring so stale font size doesn't flash (non-resize only)
        if (!isResize) {
            container.style.visibility = 'hidden';
        }
        clearTimeout((_a = previewRafRef.current) !== null && _a !== void 0 ? _a : undefined);
        previewRafRef.current = setTimeout(function () {
            var _a;
            var _b = measurePreviewFontSize(), newSize = _b.size, shouldWrap = _b.shouldWrap;
            var editor = container.querySelector('.displayCard .editorDiv');
            // Accumulate this card's natural size and compute display size
            measuredPopupSizesRef.current = __assign(__assign({}, measuredPopupSizesRef.current), (_a = {}, _a[lastActiveMathInput] = newSize, _a));
            var allSizes = Object.values(measuredPopupSizesRef.current);
            var displaySize = uniformFontSize
                ? allSizes.length > 0
                    ? Math.min.apply(Math, allSizes) : newSize
                : newSize;
            if (editor)
                editor.style.fontSize = "".concat(displaySize, "px");
            if (!isResize) {
                container.style.visibility = 'visible';
            }
            setPreviewShouldWrap(shouldWrap);
            setPreviewFontSize(displaySize);
        }, 100);
        return function () {
            var _a;
            clearTimeout((_a = previewRafRef.current) !== null && _a !== void 0 ? _a : undefined);
            if (!isResize && container)
                container.style.visibility = 'visible';
        };
    }, [
        JSON.stringify(cards),
        lastActiveMathInput,
        orientationMode,
        uniformFontSize,
        allCardsEmpty,
        resizeKey,
    ]);
    // Auto-size premade text deck thumbnails after render
    useEffect(function () {
        var _a;
        var wrapper = deckCardWrapperRef.current;
        if (!wrapper || deckType !== 0 || deckIdx === -1)
            return;
        if (((_a = cards[0]) === null || _a === void 0 ? void 0 : _a.type) !== 'text')
            return;
        var refCardW = orientationMode === 'landscape' ? 301 : 215;
        var refCardH = orientationMode === 'landscape' ? 215 : 301;
        var refAvailW = refCardW * 0.8;
        var refAvailH = refCardH * 0.8;
        var timer = setTimeout(function () {
            var cardTextEls = wrapper.querySelectorAll('.cardText');
            cardTextEls.forEach(function (container) {
                var editor = container.querySelector('.displayCard .editorDiv');
                if (!editor)
                    return;
                var thumbnailW = container.clientWidth;
                var thumbnailH = container.clientHeight;
                if (thumbnailW <= 0 || thumbnailH <= 0)
                    return;
                // Wrap decision uses reference card space (Apr 14: correct threshold).
                // Font sizing uses actual container dims (Mar 23: correct recentering).
                var thumbnailScale = thumbnailW / refCardW;
                var marginW = thumbnailW * 0.15;
                var marginH = thumbnailH * 0.15;
                var availW = thumbnailW - marginW * 2;
                var availH = thumbnailH - marginH * 2;
                var origFontSize = editor.style.fontSize;
                var origW = editor.style.width;
                var origH = editor.style.height;
                var origO = editor.style.overflow;
                var origWS = editor.style.whiteSpace;
                // Phase 1: measure at BASE size, single-line
                editor.style.fontSize = "".concat(BASE_PREVIEW_FONT_SIZE, "px");
                editor.style.width = 'max-content';
                editor.style.height = 'max-content';
                editor.style.overflow = 'visible';
                editor.style.whiteSpace = 'nowrap';
                var cW = editor.scrollWidth;
                var cH = editor.scrollHeight;
                if (cW === 0 || cH === 0) {
                    editor.style.fontSize = origFontSize;
                    editor.style.width = origW;
                    editor.style.height = origH;
                    editor.style.overflow = origO;
                    editor.style.whiteSpace = origWS;
                    return;
                }
                // Use reference-card scale for the wrap threshold check so the same
                // text is wrapped/unwrapped regardless of thumbnail pixel size.
                var refSingleLineScale = Math.min(refAvailW / cW, refAvailH / cH);
                var refSingleLineSize = Math.floor(BASE_PREVIEW_FONT_SIZE * refSingleLineScale);
                if (refSingleLineSize >= WRAP_THRESHOLD_FONT_SIZE) {
                    // No wrap — scale to actual thumbnail dimensions (Mar 23 approach)
                    editor.style.fontSize = origFontSize;
                    editor.style.width = origW;
                    editor.style.height = origH;
                    editor.style.overflow = origO;
                    editor.style.whiteSpace = origWS;
                    container.classList.remove('wrap-text');
                    var scale = Math.min(availW / cW, availH / cH);
                    var newSize = Math.min(Math.max(1, Math.floor(BASE_PREVIEW_FONT_SIZE * scale) - 1), BASE_PREVIEW_FONT_SIZE);
                    editor.style.fontSize = "".concat(newSize, "px");
                }
                else {
                    // Phase 2: measure wrapped height in reference card space, then
                    // scale the result down to thumbnail size (Apr 14 approach)
                    editor.style.fontSize = "".concat(WRAP_THRESHOLD_FONT_SIZE, "px");
                    editor.style.width = "".concat(refAvailW, "px");
                    editor.style.height = 'max-content';
                    editor.style.overflow = 'visible';
                    editor.style.whiteSpace = 'normal';
                    var wrappedH = editor.scrollHeight;
                    editor.style.fontSize = origFontSize;
                    editor.style.width = origW;
                    editor.style.height = origH;
                    editor.style.overflow = origO;
                    editor.style.whiteSpace = origWS;
                    if (wrappedH === 0)
                        return;
                    var refSize = wrappedH <= refAvailH
                        ? WRAP_THRESHOLD_FONT_SIZE
                        : Math.max(1, Math.floor(WRAP_THRESHOLD_FONT_SIZE * (refAvailH / wrappedH)));
                    container.classList.add('wrap-text');
                    editor.style.fontSize = "".concat(Math.max(1, Math.floor(refSize * thumbnailScale)), "px");
                }
            });
        }, 200);
        return function () { return clearTimeout(timer); };
    }, [deckIdx, gradeIdx, deckType, orientationMode, cards, resizeKey]);
    var renderCreateYourOwnDeck = function () {
        return (_jsxs("fieldset", { id: 'createDeck', className: "createDeckWrapper ".concat(deckType === 0 ? 'hideDeckWrapper' : ''), children: [_jsx("legend", { style: {
                        position: 'absolute',
                        width: '1px',
                        height: '1px',
                        padding: 0,
                        margin: '-1px',
                        overflow: 'hidden',
                        clip: 'rect(0, 0, 0, 0)',
                        whiteSpace: 'nowrap',
                        border: 0,
                    }, children: t('text.createYourOwn') }), _jsxs("div", { style: {
                        display: 'flex',
                        position: 'relative',
                        height: 'auto',
                        width: '100%',
                    }, children: [_jsx("span", { className: "createDeckLabel", id: "numberOfCardsLabel", ref: createDeckLabelRef, children: t('text.numberOfCards') }), _jsx("span", { className: "cardnumberIndicator", ref: cardIndicatorRef, role: "status", "aria-labelledby": "numberOfCardsLabel", children: totalCount })] }), _jsxs("div", { className: "cardsCreatorWrapper", children: [_jsx("div", { className: "content", children: _jsx(CustomScrollbar, { direction: "vertical", tabIndex: -1, children: _jsx("div", { className: "contentWrapper", ref: contentWrapperRef, children: cards.map(function (card, index) {
                                        var _a, _b, _c, _d;
                                        return (_jsxs("div", { className: "cardCreateWrapper", role: "group", "aria-label": t('text.cardGroup', { number: index + 1 }), children: [_jsx(CheckBox, { id: "cardCheckbox_".concat(index), className: "cardCheckbox", checked: checkedCards.has(index), disabled: cards.length <= 1, tabIndex: cards.length <= 1 ? -1 : undefined, onClick: function () {
                                                        setCheckedCards(function (prev) {
                                                            var next = new Set(prev);
                                                            var wasChecked = next.has(index);
                                                            if (wasChecked)
                                                                next.delete(index);
                                                            else
                                                                next.add(index);
                                                            setPopupAnnounce(wasChecked
                                                                ? t('text.cardDeselected', { index: index + 1 })
                                                                : t('text.cardSelectedOrder', {
                                                                    index: index + 1,
                                                                    order: next.size,
                                                                }));
                                                            return next;
                                                        });
                                                    }, ariaLabel: t('text.selectCard', { number: index + 1 }) }), card.type === 'text' && (_jsx(MathEditor, { data: {
                                                        type: 'data',
                                                        data: {
                                                            text: (card === null || card === void 0 ? void 0 : card.text) || [{ type: 'text', value: '' }],
                                                            color: '#293273',
                                                            alignment: 'center',
                                                        },
                                                    }, color: "#293273", className: "cardInputField", placeHolder: '', isTextUpdate: false, index: index, idPreffix: 'cardMathText', onFocusEvent: true, cb: handleTextChange, keypadButtons: bottomToolConfig.mathKeypad, bottomBtns: bottomToolConfig.mathKeypadBottom, disableTransform: true, setActiveMathText: setActiveMathInput, viewonly: false, throwChangeOnBlur: true, maxCharacters: 7, ref: function (el) {
                                                        if (el) {
                                                            mathEditorRefs.current[index] = el;
                                                        }
                                                    }, isManipulative: true, scrollIntoViewOnFocus: true })), _jsxs("div", { className: "createBtnWrapper", children: [_jsx(ButtonComponent, { type: "imageType5", imgSrc: __assign({}, btnConfig.mathtext.imgSrc), 
                                                            // disabled={inputType === diceTypeOptions[0] || !activeStates[index]}
                                                            defaultCSS: "mathTextBtn", clickActive: true, isActive: activeMathInput === index, controlActiveFromOutside: true, clickHandler: function () {
                                                                addMathText(index);
                                                            }, showToolTip: true, direction: index !== 0 && index === cards.length - 1 ? 'top' : 'bottom', isParentRelative: true, title: t('text.openMathKeypad'), ariaLabel: t('text.openMathKeypad'), ariaHaspopup: true, ariaExpanded: activeMathInput === index, disabled: ((_b = (_a = mathEditorRefs === null || mathEditorRefs === void 0 ? void 0 : mathEditorRefs.current) === null || _a === void 0 ? void 0 : _a[index]) === null || _b === void 0 ? void 0 : _b.mathFieldInstancesCount()) === 2, tabIndex: ((_d = (_c = mathEditorRefs === null || mathEditorRefs === void 0 ? void 0 : mathEditorRefs.current) === null || _c === void 0 ? void 0 : _c[index]) === null || _d === void 0 ? void 0 : _d.mathFieldInstancesCount()) === 2
                                                                ? -1
                                                                : undefined }), _jsx(ButtonComponent, { type: "imageType4", defaultCSS: "btn4", imgSrc: btnConfig.minus2.imgSrc, clickHandler: function () {
                                                                updateCount(index, -1);
                                                            }, disabled: card.count === localObj.minCardCount, tabIndex: card.count === localObj.minCardCount ? -1 : undefined, ariaLabel: t('text.decreaseCardCountFor', {
                                                                number: index + 1,
                                                                count: card.count,
                                                            }) }), _jsx("div", { className: "counter", tabIndex: -1, "aria-label": t('text.cardCountLabel', { count: card.count }), ref: function (el) {
                                                                if (el) {
                                                                    cardCountRefs.current[index] = el;
                                                                }
                                                            }, children: card.count }), _jsx(ButtonComponent, { type: "imageType4", defaultCSS: "btn4", imgSrc: btnConfig.plus2.imgSrc, clickHandler: function () {
                                                                {
                                                                    updateCount(index, 1);
                                                                }
                                                            }, disabled: card.count === localObj.maxCardCount, tabIndex: card.count === localObj.maxCardCount ? -1 : undefined, ariaLabel: t('text.increaseCardCountFor', {
                                                                number: index + 1,
                                                                count: card.count,
                                                            }) })] })] }, card.probabilityId));
                                    }) }) }) }), _jsxs("div", { className: "footerAction", children: [_jsx("div", { style: { position: 'relative' }, children: _jsx(ButtonComponent, { type: "imageType4", imgSrc: btnConfig.delete2.imgSrc, clickHandler: function () {
                                            var count = checkedCards.size;
                                            setCards(function (prev) {
                                                var newCards = prev.filter(function (_, i) { return !checkedCards.has(i); });
                                                if (newCards.length === 0)
                                                    newCards = [
                                                        {
                                                            probabilityId: "cardProbability_".concat(uuidv4().replace(/-/g, '')),
                                                            text: [{ type: 'text', value: '' }],
                                                            count: 1,
                                                            type: 'text',
                                                            lock: { positioning: false, editing: false },
                                                            multipleProbabilityCard: [createProbabilityCard()],
                                                        },
                                                    ];
                                                if (lastActiveMathInput >= newCards.length) {
                                                    setLastActiveMathInput(Math.max(0, newCards.length - 1));
                                                }
                                                setPopupAnnounce(t('text.cardsDeletedAnnounce', { count: count, remaining: newCards.length }));
                                                return newCards;
                                            });
                                            setCheckedCards(new Set());
                                        }, disabled: checkedCards.size === 0, tabIndex: checkedCards.size === 0 ? -1 : undefined, ariaLabel: checkedCards.size > 0
                                            ? t('text.deleteSelectedCards', { count: checkedCards.size })
                                            : t('text.deleteCard'), showToolTip: true, title: t('text.delete'), direction: 'top', isParentRelative: true }) }), _jsx("div", { className: "addCardContainer", children: _jsx(ButtonComponent, { type: "textType2", defaultCSS: "btn2", text: t('text.addCard'), clickHandler: function () {
                                            setCards(function (prev) {
                                                var newCards = __spreadArray(__spreadArray([], prev, true), [
                                                    {
                                                        probabilityId: "cardProbability_".concat(uuidv4().replace(/-/g, '')),
                                                        text: [{ type: 'text', value: '' }],
                                                        count: 1,
                                                        multipleProbabilityCard: [createProbabilityCard()],
                                                        lock: { positioning: false, editing: false },
                                                        type: 'text',
                                                    },
                                                ], false);
                                                setPopupAnnounce(t('text.cardAddedAnnounce', {
                                                    index: newCards.length,
                                                    total: newCards.length,
                                                }));
                                                return newCards;
                                            });
                                            setTimeout(function () {
                                                var _a, _b;
                                                (_b = (_a = contentWrapperRef.current) === null || _a === void 0 ? void 0 : _a.lastElementChild) === null || _b === void 0 ? void 0 : _b.scrollIntoView({
                                                    behavior: 'smooth',
                                                });
                                            }, 0);
                                        }, disabled: cards.length === 52, tabIndex: cards.length === 52 ? -1 : undefined, ariaLabel: t('text.addCard') }) })] })] })] }));
    };
    var updateTotalCount = function () {
        var count = 0;
        document.querySelectorAll('.counter').forEach(function (el) {
            count += parseInt(el.textContent || '0');
        });
        setTotalCount(count);
    };
    var renderLeftPanel = function () {
        var _a, _b;
        return (_jsxs("div", { className: "leftPanel", children: [_jsxs("div", { className: "modeController", role: "group", "aria-label": t('text.cardOrientation'), children: [_jsxs("div", { className: "cardsTab", role: "presentation", children: [_jsx(ButtonComponent, { defaultCSS: "cardsTabBtn cardProtrait", normalCSS: "cardTabNormal", imgSrc: btnConfig.cardsProtraitTab.imgSrc, clickActive: true, isActive: orientationMode === 'portrait', clickHandler: function () { return setOrietationMode('portrait'); }, controlActiveFromOutside: true, ariaLabel: "text.portraitOrientation", ariaPressed: orientationMode === 'portrait' }), _jsx("div", { className: "cardSelectedBottom ".concat(orientationMode === 'portrait' ? 'visible' : ''), "aria-hidden": "true" })] }), _jsxs("div", { className: "cardsTab", role: "presentation", children: [_jsx(ButtonComponent, { defaultCSS: "cardsTabBtn cardLandscape", normalCSS: "cardTabNormal", imgSrc: btnConfig.cardsLandscapeTab.imgSrc, clickActive: true, isActive: orientationMode === 'landscape', clickHandler: function () { return setOrietationMode('landscape'); }, controlActiveFromOutside: true, ariaLabel: "text.landscapeOrientation", ariaPressed: orientationMode === 'landscape' }), _jsx("div", { className: "cardSelectedBottom ".concat(orientationMode === 'landscape' ? 'visible' : ''), "aria-hidden": "true" })] })] }), _jsxs("div", { className: "cardWrapper", children: [((deckType === 0 && deckIdx === -1) || (deckType === 1 && allCardsEmpty)) && (_jsx("div", { className: "cardPreview ".concat(orientationMode), children: _jsx("img", { src: getImageSrc(orientationMode === 'landscape' ? localObj.deckLandscape : localObj.deckPortrait), alt: t('text.deckLabel'), draggable: false }) })), ((deckType === 0 && deckIdx !== -1) || (deckType === 1 && !allCardsEmpty)) && (_jsxs("div", { className: "cardPreviewWrapper ".concat(orientationMode), children: [_jsx("div", { className: "backCard", children: _jsx("img", { src: getImageSrc(orientationMode === 'landscape'
                                            ? localObj.cardBackLandscape
                                            : localObj.cardBackPortrait), alt: t('text.backCard'), draggable: false }) }), _jsxs("div", { className: "frontCard", children: [_jsx("img", { className: "frontCardImg", src: getImageSrc(orientationMode === 'landscape'
                                                ? localObj.cardFrontLandscape
                                                : localObj.cardFrontPortrait), alt: t('text.frontCard'), draggable: false }), _jsxs("div", { className: "cardText".concat(previewShouldWrap ? ' wrap-text' : ''), ref: cardTextRef, children: [deckType === 1 && (_jsx(MathEditor, { data: {
                                                        type: 'data',
                                                        data: {
                                                            text: Array.isArray(cards[lastActiveMathInput].text)
                                                                ? cards[lastActiveMathInput].text.filter(function (item) { return item.type !== 'text' || item.value !== '\u200B'; })
                                                                : cards[lastActiveMathInput].text,
                                                            color: '#000000',
                                                            alignment: 'center',
                                                            size: previewFontSize,
                                                        },
                                                    }, color: "#000000", className: "displayCard", isTextUpdate: false, idPreffix: "cardPopupImage", index: 0, keypadButtons: bottomToolConfig.mathKeypad, bottomBtns: bottomToolConfig.mathKeypadBottom, disableTransform: true, isManipulative: true, viewonly: true }, "cardPopupPreview")), deckType === 0 &&
                                                    deckIdx !== -1 &&
                                                    (((_a = cards[0]) === null || _a === void 0 ? void 0 : _a.type) === 'image' ? (_jsx("img", { src: getImageSrc(typeof cards[0].text === 'string' ? cards[0].text : ''), className: "cardImage", onLoad: function (e) {
                                                            var img = e.currentTarget;
                                                            img.classList.remove('cardImage--svg');
                                                            if (img.naturalHeight / img.naturalWidth < 1.2) {
                                                                img.classList.add('cardImage--svg');
                                                            }
                                                        }, draggable: false, alt: "Deck preview" })) : (_jsx(MathEditor, { data: {
                                                            type: 'data',
                                                            data: {
                                                                text: ((_b = cards[0]) === null || _b === void 0 ? void 0 : _b.text) || [{ type: 'text', value: '' }],
                                                                color: '#000000',
                                                                alignment: 'center',
                                                                size: previewFontSize,
                                                            },
                                                        }, color: "#000000", className: "displayCard", isTextUpdate: false, index: 0, idPreffix: 'previewCardText', viewonly: true, isManipulative: true })))] })] })] }))] })] }));
    };
    // Guard: skip initial mount since initialCardsState already computed from propsCard
    var initializedFromProps = useRef(!!propsCard);
    useEffect(function () {
        if (initializedFromProps.current) {
            initializedFromProps.current = false;
            return;
        }
        if (!SHOW_SQUENCE_ORDER_FROM_PROPS) {
            propsCard && setCards(convertSingleCardFaceToCards(propsCard));
        }
        else {
            if (!propsCard)
                return;
            var convertedCards_1 = convertSingleCardFaceToCards(propsCard);
            // Restore selectedCardOrder from sequenceOrder in propsCard
            var orderMap_2 = [];
            convertedCards_1.forEach(function (card, cardIndex) {
                var face = propsCard.find(function (f) { return f.probabilityId === card.probabilityId && f.sequenceOrder != null; });
                if (face && face.sequenceOrder != null) {
                    orderMap_2.push({ cardIndex: cardIndex, sequenceOrder: face.sequenceOrder });
                }
            });
            if (orderMap_2.length > 0) {
                orderMap_2.sort(function (a, b) { return a.sequenceOrder - b.sequenceOrder; });
                // Reorder cards: selected cards first (in sequence order), then the rest
                var selectedIndices_2 = new Set(orderMap_2.map(function (o) { return o.cardIndex; }));
                var selectedCards = orderMap_2.map(function (o) { return convertedCards_1[o.cardIndex]; });
                var unselectedCards = convertedCards_1.filter(function (_, i) { return !selectedIndices_2.has(i); });
                var reorderedCards = __spreadArray(__spreadArray([], selectedCards, true), unselectedCards, true);
                setCards(reorderedCards);
                // Selected cards are now at indices 0..N-1
                setSelectedCardOrder(orderMap_2.map(function (_, i) { return i; }));
            }
            else {
                setCards(convertedCards_1);
            }
        }
    }, [propsCard]);
    useEffect(function () {
        setOrietationMode(rotate ? 'landscape' : 'portrait');
    }, [rotate]);
    useEffect(function () {
        setCards(function (_cards) {
            var _a;
            var deckData = deckType === 0 && gradeIdx !== -1 && deckIdx !== -1
                ? (_a = localObj.deck[gradeIdx]) === null || _a === void 0 ? void 0 : _a[deckIdx]
                : null;
            var hasOrientationImages = (deckData === null || deckData === void 0 ? void 0 : deckData.images) && (deckData === null || deckData === void 0 ? void 0 : deckData.landscapeImages);
            return _cards.map(function (_card) {
                var updatedCard = __assign({}, _card);
                if (hasOrientationImages && _card.type === 'image') {
                    var imageList = orientationMode === 'landscape' ? deckData.landscapeImages : deckData.images;
                    // Match by the card's own current image path, not by its position in
                    // `_cards` — selected cards get moved to the front of the array (see
                    // the "come out first" reconstruction), so a card's array index no
                    // longer lines up with its slot in the deck's fixed images /
                    // landscapeImages arrays. Matching by position silently swapped in
                    // whatever image naturally sat at that deck slot instead of this
                    // card's own image.
                    var deckIndex = (function () {
                        var _a, _b, _c, _d;
                        var inPortrait = (_b = (_a = deckData.images) === null || _a === void 0 ? void 0 : _a.indexOf(_card.text)) !== null && _b !== void 0 ? _b : -1;
                        return inPortrait !== -1
                            ? inPortrait
                            : (_d = (_c = deckData.landscapeImages) === null || _c === void 0 ? void 0 : _c.indexOf(_card.text)) !== null && _d !== void 0 ? _d : -1;
                    })();
                    if (deckIndex !== -1 && imageList[deckIndex] !== undefined) {
                        updatedCard.text = imageList[deckIndex];
                    }
                }
                return __assign(__assign({}, updatedCard), { multipleProbabilityCard: _card.multipleProbabilityCard.map(function (_singleCard) {
                        return __assign(__assign({}, _singleCard), { dimensions: __assign({}, initialDimension) });
                    }) });
            });
        });
    }, [orientationMode]);
    useEffect(function () {
        if (deckType === 1)
            updateTotalCount();
    }, [cards]);
    useEffect(function () {
        if (runnedFirstTime.current) {
            setGradeIdx(-1);
            setDeckIdx(-1);
            setSelectedCardOrder([]);
            setCards(function (prev) {
                var newState = __spreadArray([], prev, true);
                newState = Array.from({ length: 5 }).map(function (_, i) { return ({
                    probabilityId: "cardProbability_".concat(uuidv4().replace(/-/g, '')),
                    text: [{ type: 'text', value: '' }],
                    count: 1,
                    type: 'text',
                    lock: { positioning: false, editing: false },
                    multipleProbabilityCard: [createProbabilityCard()],
                }); });
                return newState;
            });
        }
        else
            runnedFirstTime.current = true;
    }, [deckType]);
    useEffect(function () {
        runnedFirstTime.current = false;
    }, []);
    var addMathText = function (index) {
        setSelectedTool(["cardMathText_".concat(index)]);
        setTimeout(function () {
            var _a;
            (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.insertMath();
        }, 10);
        // setActiveMathInput(index);
    };
    useEffect(function () {
        if (deckType !== 1) {
            setAllCardsEmpty(true);
            setAllCardsFilled(false);
            return;
        }
        var empty = cards.every(function (_, index) {
            var _a;
            var count = (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.getTotalCharacterCount(true);
            return (count !== null && count !== void 0 ? count : 0) === 0;
        });
        var filled = cards.every(function (_, index) {
            var _a;
            var count = (_a = mathEditorRefs.current[index]) === null || _a === void 0 ? void 0 : _a.getTotalCharacterCount(true);
            return (count !== null && count !== void 0 ? count : 0) > 0;
        });
        setAllCardsEmpty(empty);
        setAllCardsFilled(filled);
    }, [cards, deckType]);
    return (_jsxs("div", { className: "cardDeckWrapper", children: [_jsxs("div", { style: {
                    width: "100%",
                    height: "100%",
                    display: 'flex',
                    flexDirection: 'column',
                    justifyContent: 'space-between',
                }, "data-mfdeselect": "true", children: [_jsx(CustomScrollbar, { className: "verticalList", direction: "vertical", tabIndex: -1, onChange: function () {
                            alignIndicatorWithFirstCounter();
                        }, children: _jsxs("div", { className: "cardDeckContainer", children: [renderLeftPanel(), _jsx("div", { className: "divider", "aria-orientation": "vertical", "aria-hidden": "true" }), _jsxs("div", { className: "rightPanel", style: deckType === 0 ? {} : { gap: '1dvh' }, children: [_jsxs("fieldset", { className: "fieldsetFlex", style: deckType === 0 ? {} : { paddingBottom: '0.8%' }, children: [_jsx("legend", { className: "sectionTitle", "aria-hidden": "true", children: t('text.cardDecks') }), _jsx(RadioButton, { id: "cardDeckSelector", options: localObj.deckType, selected: deckType, onChange: handleDeckType, className: "radioGroup", name: "deckType" })] }), _jsx("div", { className: "horizontalDivider", "aria-hidden": "true" }), deckType === 0 && renderPreMadeDeck(), deckType === 1 && renderCreateYourOwnDeck()] })] }) }), _jsx(FooterActionsButtons, { disableDoneBtn: (deckType === 0 && deckIdx === -1) || (deckType === 1 && !allCardsFilled), hideCancel: false, onActionBtnClick: function (type) {
                            switch (type) {
                                case 'done': {
                                    var cardsData_1 = [];
                                    cards.forEach(function (_card, cardIndex) {
                                        var isSelected = selectedCardOrder.includes(cardIndex);
                                        var selectionIndex = selectedCardOrder.indexOf(cardIndex);
                                        _card.multipleProbabilityCard.forEach(function (cardCount) {
                                            var tempCD = __assign(__assign({}, cardCount), { probabilityId: _card.probabilityId, text: _card.text, zIndex: 0, type: _card.type, deckId: '', shouldShuffle: selectedCardOrder.length > 0 ? !isSelected : true, sequenceOrder: isSelected ? selectionIndex + 1 : undefined });
                                            cardsData_1.push(tempCD);
                                        });
                                    });
                                    // Selected cards first (in selection order), then shuffle the rest
                                    var selectedCards_1 = [];
                                    selectedCardOrder.forEach(function (cardIndex) {
                                        var card = cards[cardIndex];
                                        card.multipleProbabilityCard.forEach(function (cardCount) {
                                            var existing = cardsData_1.find(function (c) { return c.id === cardCount.id; });
                                            if (existing)
                                                selectedCards_1.push(existing);
                                        });
                                    });
                                    var shuffleCards = shuffleArray(cardsData_1.filter(function (c) { return c.shouldShuffle; }));
                                    var finalCards = __spreadArray(__spreadArray([], selectedCards_1, true), shuffleCards, true);
                                    onSubmit &&
                                        onSubmit({
                                            cards: finalCards,
                                            rotate: orientationMode === 'landscape',
                                            deckType: deckType === 0 ? 'preMadeDeck' : 'customDeck',
                                            deckIdx: deckIdx,
                                            gradeIdx: gradeIdx,
                                        });
                                    break;
                                }
                                case 'cancel':
                                    onCancel && onCancel();
                                    break;
                            }
                        } })] }), _jsx("div", { "aria-live": "polite", "aria-atomic": "true", style: {
                    position: 'absolute',
                    width: '1px',
                    height: '1px',
                    padding: 0,
                    margin: '-1px',
                    overflow: 'hidden',
                    clip: 'rect(0, 0, 0, 0)',
                    whiteSpace: 'nowrap',
                    border: 0,
                }, children: popupAnnounce })] }));
};
export default CardsManipulativePopup;
